webpackJsonp([26232365476391],{

/***/ 1414:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"CustomClientFieldInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"name","type":{"kind":"SCALAR","name":"String","ofType":null}},{"defaultValue":null,"description":null,"name":"type","type":{"kind":"SCALAR","name":"String","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---input-object-custom-client-field-input-c58f120b33d5fa8c2a99.js